import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "small text-muted" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.names.length === 1 ? 'z podkladu' : 'z podkladů') + " " + _toDisplayString(_ctx.names.join(', ')), 1),
    (_ctx.quotes.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[1] || (_cache[1] = _createTextVNode(", ", -1)),
          _createElementVNode("a", {
            href: "#",
            class: "link-secondary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.quotesShown = !_ctx.quotesShown), ["prevent"]))
          }, _toDisplayString(_ctx.quotesShown ? 'skrýt citaci' : 'ukázat citaci'), 1)
        ], 64))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotesShown ? _ctx.quotes : [], (quote, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "fst-italic border-start ps-2 mt-1"
      }, [
        _createTextVNode(" „" + _toDisplayString(quote.quote) + "“", 1),
        (quote.page !== null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", strana " + _toDisplayString(quote.page), 1))
          : _createCommentVNode("", true),
        (_ctx.names.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, ", " + _toDisplayString(quote.sourceName), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}